/// <reference path="../../lib/app.d.ts" />



import {EmojiConverter} from "../lib/emoji-converter";
import {Application} from "../application/application";
export class StickerPanel
{
	private TAG = "[StickerPanel]";

	private emojis = [
		"&#x1f642;",
		"&#x1f641;",
		"&#x1f600;",
		"&#x1f644;",
		"&#x1f910;",

		"&#x1f912;",
		"&#x1f913;",
		"&#x1f914;",

		"&#x1f601;",
		"&#x1f602;",
		"&#x1f603;",
		"&#x1f604;",
		"&#x1f605;",
		"&#x1f606;",
		"&#x1f609;",
		"&#x1f60A;",
		"&#x1f60B;",
		"&#x1f60C;",
		"&#x1f60D;",
		"&#x1f60F;",
		"&#x1f612;",
		"&#x1f613;",
		"&#x1f614;",
		"&#x1f616;",
		"&#x1f618;",
		"&#x1f61A;",
		"&#x1f61C;",
		"&#x1f61D;",
		"&#x1f61E;",
		"&#x1f620;",
		"&#x1f621;",
		"&#x1f622;",
		"&#x1f623;",
		"&#x1f624;",
		"&#x1f625;",
		"&#x1f628;",
		"&#x1f629;",
		"&#x1f62A;",
		"&#x1f62B;",
		"&#x1f62D;",
		"&#x1f630;",
		"&#x1f631;",
		"&#x1f632;",
		"&#x1f635;",
		"&#x1f637;",
		"&#x1f638;",
		"&#x1f639;",
		"&#x1f63A;",
		"&#x1f63B;",
		"&#x1f63C;",
		"&#x1f63D;",
		"&#x1f63E;",
		"&#x1f63F;",
		"&#x1f640;",
		"&#x1f648;",
		"&#x1f649;",
		"&#x1f64A;",
		"&#x2764;",
		"&#x1F494;",
		"&#x1F607;",
		"&#x1F608;",
		"&#x1F60E;",
		"&#x1F610;",
		"&#x1F611;",
		"&#x1F615;",
		"&#x1F617;",
		"&#x1F619;",
		"&#x1F61B;",
		"&#x1F61F;",
		"&#x1F626;",
		"&#x1F627;",
		"&#x1F62c;",
		"&#x1F62E;",
		"&#x1F62F;",
		"&#x1F634;",
		"&#x1F636;"
	];

	private stickers = {
		"girls": {
			items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
			"icon": 1,
		},
		"couples": {
			items: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
			"icon": 38,
		},
	};

	private $header: JQuery;
	private $groups: JQuery;
	private $groups2: JQuery;
	private $footer: JQuery;
	private enabled: boolean = true;
	private visibleGroup : string = "emoji";
	private stickersAllowed : boolean = true;
	private couplesStickersAllowed : boolean = true;

	constructor(private $root: JQuery,
	            private emojiConverter: EmojiConverter,
	            private app: Application,
	            private onEmojiSelected : (emoji : string) => void,
	            private onStickerSelected : (stickerID : string) => void,
	            private onGroupChanged : () => void
	)
	{
		this.$header = this.$root.find(".sxccs-header");
		this.$groups = this.$root.find(".sxccs-groups");
		this.$groups2 = this.$root.find(".sxccs-groups2");
		this.$footer = this.$root.find(".sxccs-footer");

		this.$groups2.sxcCustomScroll("init");

		this.addEmojiGroup(this.emojis);
		this.addStickerGroup("girls", this.stickers.girls);
		this.addStickerGroup("couples", this.stickers.couples);

		this.$footer.find("button").on("click", e =>
		{
			if (!this.enabled) return;
			const id = $(e.currentTarget).data("id");

			if (id === "couples" && !this.couplesStickersAllowed) return;
			if (id !== "emoji" && !this.stickersAllowed) return;

			this.showGroup(id);
		});

		this.$groups.find("button.emoji").on("mouseover", (e) =>
		{
			if (!this.enabled) return;
			this.$header.find(".sxccs-choose").hide();
			this.$header.find(".sxccs-chosen")
				.addClass("sxc-visible")
				.empty()
				.append($(e.currentTarget).html());
		});

		this.$groups.find("button.sticker").on("mouseover", (e) =>
		{
			if (!this.enabled) return;
			this.$header.find(".sxccs-choose").hide();
			this.$header.find(".sxccs-chosen")
				.addClass("sxc-visible")
				.empty()
				.append($(e.currentTarget).html());
		});

		this.$groups.find("button.emoji").on("click", (e) => {
			if (!this.enabled) return;
			let u = $(e.currentTarget).find("span").data("sxc-u");
			this.onEmojiSelected(u);
		});

		$(".sxcc-fixed-body").find("button.emoji").on("click", (e) => {
			if (!this.enabled) return;
			let u = $(e.currentTarget).find("span").data("sxc-u");
			this.onEmojiSelected(u);
		});

		this.$groups.find("button.sticker").on("click", (e) => {
			if (!this.enabled) return;
			let id = $(e.currentTarget).data("id");
			this.onStickerSelected(id);
		});

		// Cache emojis
		for (let emoji of this.emojis) {
			let unicode = $("<span />").html(emoji).text();
			$("#sxc-image-cache-container").append(this.emojiConverter.unicodeToImage(unicode));
		}

		$(window).resize(this.triggerResize.bind(this));

		this.showGroup("emoji");
	}

	resizeMargins(groupType : string, $group : JQuery)
	{
		let minSpacing = 5;

		let p = 16;

		let totalW = this.$groups.width() - p * 2;
		let itemW = $group.find("button:eq(1)").innerWidth();

		let howManyFit = Math.floor(totalW / (itemW + minSpacing));
		let spacing = (totalW - howManyFit * itemW) / (howManyFit - 1);

		$group.css({
			position: "relative"
		});

		let lasti = 0;

		$group.find("button").each((i, btn) =>
		{
			lasti = i;
			let left = (i % howManyFit) * (itemW + spacing);
			let top = Math.floor(i / howManyFit) * (itemW + spacing);

			$(btn).css({
				position: "absolute",
				top: top + p,
				left: left + p,
			});
		});

		$group.css("height", (Math.floor(lasti / howManyFit) + 1) * (itemW + spacing) - spacing + 2 * p);

	}

	showGroup(id)
	{
		this.$footer.find("button").removeClass("sxc-selected");
		this.$footer.find("button[data-id=" + id + "]").addClass("sxc-selected");

		this.$header.find(".sxccs-choose").show();
		this.$header.find(".sxccs-chosen").removeClass("sxc-visible");

		this.$groups.find(".sxccs-group").removeClass("sxc-visible").hide();
		let $grp = this.$groups.find(".sxccs-group[data-id=" + id + "]");
		$grp.addClass("sxc-visible").show();
		this.resizeMargins(id, $grp);

		let $first = $grp.find("button");
		this.$header.find(".sxccs-choose").hide();
		this.$header.find(".sxccs-chosen")
			.addClass("sxc-visible")
			.empty()
			.append($first.html());

		this.visibleGroup = id;
		this.$groups2.sxcCustomScroll("update");
		this.onGroupChanged();
	}

	getStickerImg(id)
	{
		let i2 = parseInt(id,10) > 9 ? id : ("0" + id);
		return $("<img class='sxc-sticker'/>").attr("src", this.app.options.view.stickerPath + i2 + ".svg?a");
	}

	addStickerGroup(listID, list)
	{
		let $wrapper = $("<div class='sxccs-group-wrapper sxccs-sticker-group'/>")
			.attr("data-id", listID)
			.appendTo(this.$footer);

		let $groupIcon = $("<button>")
			.attr("data-id", listID)
			.append(this.getStickerImg(list.icon))
			.appendTo($wrapper);

		let $group = $("<div class='sxccs-group' />")
			.attr("data-id", listID)
			.appendTo(this.$groups.find(".custom-scroll-inner"));

		for (let sticker of list.items) {
			let $button = $("<button class='sticker'/>")
				.attr("data-id", sticker)
				.append(this.getStickerImg(sticker))
				.appendTo($group);
		}
	}

	addEmojiGroup(list)
	{
		let $wrapper = $("<div class='sxccs-group-wrapper sxccs-emoji-group'/>")
			.attr("data-id", "emoji")
			.appendTo(this.$footer);

		let $groupIcon = $("<button>")
			.attr("data-id", "emoji")
			.html("&#x1f601;")
			.appendTo(this.$footer);

		let $group = $("<div class='sxccs-group' />")
			.attr("data-id", "emoji")
			.appendTo(this.$groups.find(".custom-scroll-inner"));

		for (let emoji of this.emojis) {
			let $button = $("<button class='emoji'/>")
				.html(emoji)
				.appendTo($group);
		}
	}

	isVisible()
	{
		return this.$root.hasClass("sxc-visible");
	}

	toggle(visible = null)
	{
		// logging.log(this.TAG, "toggle", visible);

		if (visible === null) {
			this.toggle(!this.isVisible());
			return;
		}

		if (visible) {
			setTimeout(() => this.showGroup("emoji"), 1);
			this.setClickOutHandler();
		}

		this.$root[visible ? "addClass" : "removeClass"]("sxc-visible")
	}

	private setClickOutHandler()
	{
		$(document).one("click", (e2) =>
		{
			if (!$.contains(this.$root[0], e2.target)) {
				this.toggle(false);
			} else {
				this.setClickOutHandler();
			}
		});
	}

	triggerResize()
	{
		if (!this.isVisible()) return;
		let $activeGroup = this.$groups.find(".sxccs-group.sxc-visible");
		if (!$activeGroup.length) return;
		this.resizeMargins($activeGroup.data("id"), $activeGroup);
	}

	disable()
	{
		this.enabled = false;
	}
	enable()
	{
		this.enabled = true;
	}

	allowStickersBasedOn(base : "free" | "group" | "vx" | "normal")
	{
		// logging.log("allowStickers", base);
		this.stickersAllowed = base === "group" || base === "normal";
		this.couplesStickersAllowed = base === "group";

		this.$footer.find(".sxccs-group-wrapper.sxccs-sticker-group .sxc-tooltip").remove();

		if (!this.stickersAllowed)
		{
			this.$footer.find(".sxccs-group-wrapper.sxccs-sticker-group").each((i, e) =>
			{
				const text = base === "vx"
					? this.app.translator.t("sticker_panel_not_available_vx")
					: this.app.translator.t("sticker_panel_not_available_free");

				$(e)
					.addClass("sxc-tooltip-container")
					.append(
						$("<div class='sxc-tooltip sxc-tooltip-arrow-bottom sxc-tooltip-top-center'/>")
							.text(text)
					)
			});

			if (this.visibleGroup !== "emoji") {
				this.showGroup("emoji");
			}
		}
		else
		{
			this.$footer.find(".sxccs-group-wrapper.sxccs-sticker-group").removeClass("sxc-tooltip-container");

			if (!this.couplesStickersAllowed) {
				this.$footer.find(".sxccs-group-wrapper.sxccs-sticker-group[data-id=couples]")
					.addClass("sxc-tooltip-container")
					.append(
						$("<div class='sxc-tooltip sxc-tooltip-arrow-bottom sxc-tooltip-top-center'/>")
							.text(this.app.translator.t("sticker_panel_not_available_group"))
					);

				if (this.visibleGroup === "couples") {
					this.showGroup("emoji");
				}
			}
		}
	}
}
